import { WizardConfig, WizardErrors } from '../../types/wizard'

interface Props {
  config: WizardConfig
  updateConfig: (updates: Partial<WizardConfig>) => void
  errors: WizardErrors
}

const COMMON_CITIES = ['San Francisco', 'Oakland', 'Berkeley', 'San Jose', 'Palo Alto', 'Mountain View']
const PRICE_RANGES = [
  'Under $500K',
  '$500K - $750K',
  '$750K - $1M',
  '$1M - $1.5M',
  '$1.5M - $2M',
  '$2M - $3M',
  'Over $3M'
]

export default function Step3Market({ config, updateConfig, errors }: Props) {
  const toggleCity = (city: string) => {
    const cities = config.cities.includes(city)
      ? config.cities.filter(c => c !== city)
      : [...config.cities, city]
    updateConfig({ cities })
  }

  const togglePriceRange = (range: string) => {
    const priceRanges = config.priceRanges.includes(range)
      ? config.priceRanges.filter(r => r !== range)
      : [...config.priceRanges, range]
    updateConfig({ priceRanges })
  }

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-900 mb-2">Configure Your Market</h2>
      <p className="text-gray-600 mb-8">
        Help your chatbot provide relevant property suggestions by selecting your target markets.
      </p>

      <div className="space-y-8">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Cities You Serve *
          </label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {COMMON_CITIES.map(city => (
              <button
                key={city}
                onClick={() => toggleCity(city)}
                className={`px-4 py-3 rounded-lg border-2 font-medium transition-colors ${
                  config.cities.includes(city)
                    ? 'border-primary-600 bg-primary-50 text-primary-700'
                    : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
                }`}
              >
                {city}
              </button>
            ))}
          </div>
          {errors.cities && (
            <p className="mt-2 text-sm text-red-600">{errors.cities}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Price Ranges *
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {PRICE_RANGES.map(range => (
              <button
                key={range}
                onClick={() => togglePriceRange(range)}
                className={`px-4 py-3 rounded-lg border-2 font-medium transition-colors ${
                  config.priceRanges.includes(range)
                    ? 'border-primary-600 bg-primary-50 text-primary-700'
                    : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
                }`}
              >
                {range}
              </button>
            ))}
          </div>
          {errors.priceRanges && (
            <p className="mt-2 text-sm text-red-600">{errors.priceRanges}</p>
          )}
        </div>
      </div>
    </div>
  )
}
